import { Api } from '@/_core/service/api';
import handleError from '@/_core/helpers/errorHandler';
import appSettings from '@/plugins/appSettings';

export default {
  getAccessTokenFromRefreshToken(refreshToken) {
    return Api()
      .post('oauth/refresh-token/essence', {
        token: refreshToken,
      })
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getPermissions(type) {
    return Api()
      .get(`/permissions/${type}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  userLogout(endPoint, dataObj) {
    return Api()
      .post(`user/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getUserData(type, id) {
    return Api()
      .get(`/user/${type}/${id}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  deleteData(type, id) {
    return Api()
      .delete(`/deleteData/${type}/${id}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  updateData(apiKey, formData) {
    return Api()
      .put(`saveData/${apiKey}`, formData)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  addData(endPoint, dataObj) {
    return Api()
      .post(`saveData/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  addWebHookData(apiKey, formData, messageConfig = []) {
    const encodedURL = (apiKey.split('?').length > 1)
      ? apiKey.split('?')[0] + encodeURIComponent('?' + apiKey.split('?')[1])
      : apiKey;

    apiKey = `${encodedURL}`;
    return Api()
      .post(`webHook/add/?sourceURL=${apiKey}`, formData)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        const { status } = response;
        if (messageConfig.includes(status) || (response && response.data && response.data.causes && response.data.causes[0].code && (response.data.causes[0].code === 'FEDE-000138' || response.data.causes[0].code === 'FEDE-000140'))) {
          return response;
        } else {
          handleError(e);
        }
      });
  },
  deleteWebHookData(apiKey, formData) {
    return Api()
      .delete(`webHook/delete/?sourceURL=${apiKey}`, formData)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  updateWebHookData(apiKey, formData, messageConfig = []) {
    return Api()
      .put(`webHook/update/?sourceURL=${apiKey}`, formData)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        const { status } = response;

        if (messageConfig.includes(status)) {
          return response;
        } else {
          handleError(e);
        }
      });
  },
  postWebHookSearchResults(apiKey, formData) {
    return Api()
      .post(`webHook/search/?sourceURL=${apiKey}`, formData)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getWebHookSearchResults(endPoint, searchObj = {}, page = 0, size = 10, messageConfig = []) {
    const queryParams = searchObj ? this.getQueryString(searchObj) : {};
    const encodedURL = (endPoint.split('?').length > 1)
      ? endPoint.split('?')[0] + encodeURIComponent('?' + endPoint.split('?')[1])
      : encodeURIComponent(endPoint);

    const searchParams = Object.keys(searchObj).length
      ? `/webhook/search/?sourceURL=${endPoint + encodeURIComponent('?' + queryParams + '&page=' + page + '&size=' + size)}`
      : `/webhook/search/?sourceURL=${encodedURL}`;

    return Api()
      .get(searchParams)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        const { status } = response;

        if (messageConfig.includes(status)) {
          return response;
        } else {
          handleError(e);
        }
      });
  },
  getTenantId() {
    return Api()
      .get('getTenantId/')
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getPageData(url, header = {}, messageConfig = []) {
    return Api(header)
      .get(`/getPageResults/?sourceURL=${url}`)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        const { status } = response;

        if (messageConfig.includes(status)) {
          return response;
        } else {
          handleError(e);
        }
      });
  },
  getDropdownObj(endpoint, id) {
    if (!endpoint) {
      return [];
    }
    const url = id ? `${endpoint}${id}` : endpoint;
    return Api()
      .get(`/getDDResults/${url}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getSearchResults(endPoint, searchObj, page = 0, size = 10) {
    const queryParams = searchObj ? this.getQueryString(searchObj) : {};
    const searchParams = Object.keys(searchObj).length
      ? `/getPageResults/${endPoint}?${queryParams}&page=${page}&size=${size}`
      : `/getPageResults/${endPoint}?page=${page - 1}&size=${size}`;
    return Api()
      .get(searchParams)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getLocaleData(languageCode) {
    return Api()
      .get(`/locale/${languageCode}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getImageData(imagePath) {
    return Api()
      .get(`/images/?imgPath=${imagePath}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getQueryString(payloadObj) {
    return Object.keys(payloadObj)
      .map((key) => {
        if (
          this.checkVal(this.processArray(payloadObj[key])) &&
          this.checkVal(this.processArray(payloadObj[key]).length)
        ) {
          return key + '=' + this.checkVal(this.processArray(payloadObj[key]));
        }
      })
      .filter((e) => e)
      .join('&');
  },
  processArray(incData) {
    return incData
      ? Array.isArray(incData)
        ? incData.toString().trim().replace(',', '')
        : incData.toString().trim()
      : '';
  },
  checkVal(value) {
    const mappedValues = {
      YN: '',
    };

    // eslint-disable-next-line no-prototype-builtins
    if (mappedValues.hasOwnProperty(value)) {
      return mappedValues[value];
    }

    return value;
  },
  getFormSchema(url) {
    return Api()
      .get(`/form?url=${url}`)
      .then((data) => data)
      .catch((e) => handleError(e));
  },
  getFormSchemaFromLocal(formName) {
    return Api()
      .post(`api/db/schema/${formName}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getCountryCode(type, id) {
    return Api()
      .get(`/getSharedData/branch-details/${type}/${id}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getRedirectURL() {
    return Api()
      .get('/getRedirectURL')
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getEnvProperties() {
    return Api()
      .get('/getEnvProperties')
      .then(({ data }) => {
        if (appSettings?.serverSettings?.baseUrl && appSettings.serverSettings.baseUrl !== '/') {
          data.REDIRECT_URL = appSettings.serverSettings.baseUrl;
        }
        return data;
      })
      .catch((e) => handleError(e));
  },
  getNavigationSchemaBasedOnUser() {
    return Api()
      .get('/userNavigation/menu-structure', '')
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getIsMenuFromAPIEnabled() {
    return Api()
      .get('getIsMenuFromAPIEnabled/')
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getMenuStatus(path) {
    return Api()
      .post('/getMenuStatus/', { url: path })
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getHazelCastData(id) {
    return Api()
      .get(`/getHazelCastData/${id}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getAppProperties(type) {
    return Api()
      .get(`/getAppProperties/${type}`)
      .then(({ data }) => {
        return data;
      })
      .catch((e) => handleError(e));
  },
  unparkRequest(makerCheckerId) {
    return Api()
      .post('/unparkRequest', { makerCheckerId })
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  verifyFECCEnable() {
    return Api()
      .get('/isFECCEnabled')
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  rendererAPI(payloadObj) {
    return Api()
      .post('/rendererAPI/', payloadObj)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getProductInfo(endPoint) {
    return Api()
      .get(`/getProductInfo/${endPoint}`)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        handleError(e);
        return response;
      });
  },
  productValidation(endPoint, dataObj) {
    return Api()
      .post(`productValidation/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        handleError(e);
        return response;
      });
  },
  sendOTP(endPoint, dataObj, handleSpecificError) {
    return Api()
      .post(`sendOTP/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        if (handleSpecificError) {
          handleError(e);
        }
        return response;
      });
  },
  verifyOTP(endPoint, dataObj) {
    return Api()
      .post(`verifyOTP/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        handleError(e);
        return response;
      });
  },
  verifyAccount(endPoint, dataObj) {
    return Api()
      .post(`verifyAccount/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        handleError(e);
        return response;
      });
  },
  dedupCheck(endPoint, dataObj) {
    return Api()
      .post(`dedupCheck/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        handleError(e);
        return response;
      });
  },
  addressLookup(endPoint, dataObj, handleErrorEnabled) {
    return Api()
      .post(`addressLookup/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        if (handleErrorEnabled) {
          handleError(e);
        }
        return response;
      });
  },
  validateSortCode(endPoint, dataObj) {
    return Api()
      .post(`validateSortCode/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        handleError(e);
        return response;
      });
  },
  documentUpload(endPoint, dataObj) {
    return Api()
      .post(`document/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  validateIban(endPoint) {
    return Api()
      .get(`/validateIban/${endPoint}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  deleteDcoData(endPoint) {
    return Api()
      .delete(`/deleteData/${endPoint}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getSalutationDropDown(endPoint, dataObj) {
    return Api()
      .post(`/salutation/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getStatesDropDown(endPoint, dataObj, handleErrorEnabled) {
    return Api()
      .post(`/states/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        if (handleErrorEnabled) {
          handleError(e);
        }
        return response;
      });
  },
  postData(endPoint, dataObj) {
    return Api()
      .put(`/save/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        handleError(e);
        return response;
      });
  },
  postInitialData(endPoint, dataObj) {
    return Api()
      .post(`/save/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        handleError(e);
        return response;
      });
  },
  finalSubmit(endPoint, dataObj, handleErrorEnabled) {
    return Api()
      .post(`/finalSubmit/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        if (handleErrorEnabled) {
          handleError(e);
        }
        return response;
      });
  },
  residentialAddress(endPoint) {
    return Api()
      .get(`/residentialAddress/${endPoint}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getTermsAndConditions(endPoint, dataObj, handleErrorEnabled) {
    return Api()
      .post(`/termsAndConditions/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        if (handleErrorEnabled) {
          handleError(e);
        }
        return response;
      });
  },
  getDocumentUpload(endPoint, dataObj) {
    return Api()
      .post(`/getDocument/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getConsentTypes(endPoint, dataObj) {
    return Api()
      .post(`/consentTypes/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getTaxExemptionDropDown(endPoint, dataObj) {
    return Api()
      .post(`/taxExemptionStatus/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  deleteUploadedFile(endPoint) {
    return Api()
      .delete(`/deleteUploadedFile/${endPoint}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  quitApplication(endPoint, dataObj) {
    return Api()
      .post(`/quitApplication/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        if ((response && response.data && response.data.causes && response.data.causes[0].code && (response.data.causes[0].code === 'FEDE-000138' || response.data.causes[0].code === 'FEDE-000146'))) {
          return response;
        } else {
          handleError(e);
        }
      });
  },
  getYear(endPoint) {
    return Api()
      .get(`/getYear/${endPoint}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getMonth(endPoint) {
    return Api()
      .get(`/getMonth/${endPoint}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getDate(endPoint) {
    return Api()
      .get(`/getDate/${endPoint}`)
      .then(({ data }) => data)
      .catch((e) => handleError(e));
  },
  getGenericCodeList(endPoint, dataObj, handleErrorEnabled) {
    return Api()
      .post(`/taxExemptionStatus/${endPoint}`, dataObj)
      .then(({ data }) => data)
      .catch((e) => {
        const { response } = e;
        if (handleErrorEnabled) {
          handleError(e);
        }
        return response;
      });
  },
};
